/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:42:25 
 * @Last Modified by:   wangxiang 
 * @Last Modified time: 2019-11-11 13:42:25 
 */
export default {
  name: 'm-bottom-bar',
  render(h) {
    const { text } = this;

    return (
      <div class="m-bootom-bar">
        <span class="left-line"></span>{text}<span class="right-line"></span>
      </div>
    )
  },
  data() {
    return {};
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  editorConfig: {
    propsConfig: {
      text: {
        type: 'a-input',
        label: '技术支持',
        required: true,
        defaultPropValue: ''
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/module/album/plugins/m-bottom-bar.js